import { create } from 'zustand'
import type { SystemStatus } from '@/types'

interface StatusState {
  status: SystemStatus | null
  loaded: boolean
  loading: boolean
  setStatus: (status: SystemStatus) => void
  setLoading: (loading: boolean) => void
  reset: () => void
}

export const useStatusStore = create<StatusState>((set) => ({
  status: null,
  loaded: false,
  loading: false,
  setStatus: (status) => {
    // 同步关键字段到 localStorage，供工具函数读取
    if (typeof status?.quota_per_unit === 'number') {
      localStorage.setItem('quota_per_unit', String(status.quota_per_unit))
    }
    if (typeof status?.display_in_currency === 'boolean') {
      localStorage.setItem('display_in_currency', String(status.display_in_currency))
    }
    set({ status, loaded: true, loading: false })
  },
  setLoading: (loading) => set({ loading }),
  reset: () => set({ status: null, loaded: false, loading: false }),
}))
